import React from 'react';
import classNames from 'classnames';


export default class Picker extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: props.default || []
        };
    }

    _onSelect(id) {
        let newSelection = this.state.selected.slice( 0 );

        const i = newSelection.indexOf( id );
        if( i >= 0 ) {
            newSelection.splice( i, 1 );
        } else {
            newSelection.push( id );
        }

        this.setState( { selected: newSelection } );

        if( this.props.onSelect ) {
            return this.props.onSelect( newSelection );
        }
    }

    _isSelected( id ) {
        return this.state.selected.indexOf( id ) >= 0;
    }

    renderOption(key) {
        const className = classNames({ selected : this._isSelected( key ) });
        return (
            <button key={key} onClick={() => this._onSelect(key)} className={className}>
                {this.props.options[key]}
            </button>
        )
    }

    render() {
        return (
            <div className="movies-page__movie-picker">
                <h2>{this.props.title}</h2>
                {Object.keys(this.props.options).map(key => this.renderOption(key))}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./js/movies/components/Picker.jsx